/** Part of the layout viewport hidden below the keyboard/visual viewport.
 * offsetTop matters when iOS pans the page to the focused input. */
export function viewportBottomInset(
  layoutHeight: number,
  visualHeight: number,
  visualOffsetTop: number,
): number {
  return Math.max(0, layoutHeight - visualHeight - visualOffsetTop)
}
